import React from 'react';
import PropTypes from 'prop-types';

import HeaderNavMobileHamburger from './HeaderNavMobileHamburger';
import HeaderNavMobileItem from './HeaderNavMobileItem';
import HeaderNavMobileSearch from './HeaderNavMobileSearch';

const HeaderNavMobile = ({ children }) => <nav className="c-header-main-nav-mob  u-hide@desktop">
    <ul className="o-list-inline  o-list-inline--flush  c-header-main-nav-mob__list">
      {children}
    </ul>
  </nav>

export default HeaderNavMobile;

HeaderNavMobile.Hamburger = HeaderNavMobileHamburger;
HeaderNavMobile.Item = HeaderNavMobileItem;
HeaderNavMobile.Search = HeaderNavMobileSearch;

HeaderNavMobile.propTypes = {
  children: PropTypes.node.isRequired,
};
